/**
 * 用户行为记录（埋点）。
 * 与 english-user-management/src/api/user-action.js **同一套接口与口径**：
 *   POST /api/user/action/addAction
 *   参数：actionType / relationId / relationName / parentId / parentName
 *
 * actionType 操作类型：
 *  1 复制试卷（资源参考记录，教师角色）
 *  2 播放视频（智配音浏览量，教师角色）
 *  3 播放音频
 *  4 在线记录（学生登录后，定时心跳）
 *  5 离开（学生在线记录：页面隐藏 / 最小化时上报一条，供后端闭合当前在线时段）
 *
 * ⚠️ 为什么不用 util/req.js：
 *   req.js 的响应拦截器在 errorCode 非 900088 时会 alert + wx.miniProgram.redirectTo
 *   （登录过期直接跳小程序首页）。埋点是「失败也不能打扰用户」的旁路请求，
 *   后台那边用的正是 easyRequest 静默实例，所以这里同样走独立 axios 实例：
 *   只带 token，不吃 req 的响应拦截器。
 */
import axios from "axios";
import { mapQuery } from "./URLUtils";

export const USER_ACTION_TYPE = {
  COPY_PAPER: 1, // 复制试卷
  PLAY_VIDEO: 2, // 播放视频
  PLAY_AUDIO: 3, // 播放音频
  ONLINE_RECORD: 4, // 在线记录
  LEAVE: 5, // 离开（在线记录：隐藏/最小化时补报，后端据此闭合在线时段）
};

// 与 util/req.js 同一份取法：H5 的 token 由小程序 web-view 拼在 url 上
const query = mapQuery();

/**
 * 上报用户行为记录（静默：调用方自行 catch，埋点失败不打扰用户）。
 * @param {object} params
 * @param {number} params.actionType 操作类型：1复制试卷 2播放视频 3播放音频 4在线记录
 * @param {string|number} params.relationId 试卷id
 * @param {string} params.relationName 试卷名称
 * @param {string|number} params.parentId 分组id
 * @param {string} params.parentName 分组名称
 */
export function addUserAction(params) {
  return axios({
    url: "/api/user/action/addAction",
    method: "post",
    data: params,
    timeout: 10000,
    headers: {
      Authorization: "Bearer " + query.token,
    },
  });
}

export default {
  USER_ACTION_TYPE,
  addUserAction,
};
